import React from 'react';

export default function TestLanding() {
  return (
    <div className="min-h-screen bg-red-500 flex items-center justify-center">
      <h1 className="text-6xl text-white font-bold">TEST LANDING PAGE</h1>
    </div>
  );
}
